export const types = {
  INPUT: "EXPIRY_INPUT",
};

const input = (value) => ({
  type: types.INPUT,
  value,
});

export const actions = {
  input,
};
